import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

export interface UseGetTessaUserChatListOptions {
  enabled?: boolean;
}

export function useGetTessaUserChatList(
  options?: UseGetTessaUserChatListOptions
) {
  const { apiClient } = useTacticHooks();

  const {
    data: chats,
    error,
    isFetching
  } = useQuery({
    queryKey: ["tessa.chats"],

    queryFn: async () => {
      const res = await apiClient.tessa.getUserChatList();
      return res.result;
    },

    enabled: options?.enabled !== false
  });

  return { chats, error, isFetching };
}
